import React, { useState } from 'react'
import './accordion.css'
import { withPrefix } from 'gatsby'

const Accordion = ({ title, content, onOpen = () => null }) => {
  const [isActive, setIsActive] = useState(false)

  return (
    <div className="accordion-item">
      <div
        className="accordion-title"
        onClick={() => {
          if (!isActive) {
            onOpen()
          }
          setIsActive(!isActive)
        }}
      >
        <p>{title}</p>
        <div className="icon-row">
          {isActive ? (
            <img src={withPrefix('/images/arrow-up-orange.png')} alt="" />
          ) : (
            <img src={withPrefix('/images/arrow-down-orange.png')} alt="" />
          )}
        </div>
      </div>
      {isActive && <div className="accordion-content">{content}</div>}
    </div>
  )
}

export default Accordion
